import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { ArrowDropdown, Logo } from '@ifs-gcp/components';
import type { Language } from '@ifs-gcp/core/models';

import { IFS_HOMEPAGE_URL } from '@/constants/urls';
import { useUserStore } from '@/store/userStore';

import { LANGUAGES, LANGUAGE_FLAGS } from '../../constants/languages';
import { UserDropdown } from '../user-dropdown';
import styles from './header.module.scss';

export const Header = observer(() => {
  const { t } = useTranslation();
  const user = useUserStore((state) => state.userProvider);
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);

  const handleLanguageChange = (language: Language) => {
    user.language = language;
  };

  const availableLanguages = LANGUAGES.map((language) => ({
    label: t(`languages.${language}`),
    value: language,
  }));

  const selectedItem = availableLanguages.find(
    (availableLanguage) => availableLanguage.value === user.language,
  );

  return (
    <header className={styles.header}>
      <a href={IFS_HOMEPAGE_URL}>
        <Logo variant="light" />
      </a>
      <div className={styles.headerActions}>
        <ArrowDropdown<Language>
          items={availableLanguages}
          className={styles.dropdownWrapper}
          onChoose={handleLanguageChange}
          renderListElement={({ label, value }) => (
            <div className={styles.languageListElement}>
              <img src={LANGUAGE_FLAGS[value]} alt={label} />
              <span>{label}</span>
            </div>
          )}
          renderDropdownButton={() => (
            <img
              src={LANGUAGE_FLAGS[user.language]}
              alt={selectedItem?.label[user.language as never]}
            />
          )}
        />
        {isAuthenticated && <UserDropdown />}
      </div>
    </header>
  );
});
